import CatalogCategory from './stores/modules/views/catalog/category';
import CatalogProduct from './stores/modules/views/catalog/product';
import CatalogBundleProduct from './stores/modules/views/catalog/product/bundle';
import CatalogGroupedProduct from './stores/modules/views/catalog/product/grouped';
import CatalogConfigurableProduct from './stores/modules/views/catalog/product/configurable';

export {CatalogCategory, CatalogProduct, CatalogBundleProduct, CatalogGroupedProduct, CatalogConfigurableProduct};
